import React, { useState } from "react";
import BarclaysLogo from "../../assets/logo/BarclaysLogo.svg";
import Barclays from "../../assets/logo/Barclays-Logo.svg";

import RevolutLogo from "../../assets/logo/Revolut.svg";
import MonzoLogo from "../../assets/logo/MonzoLogo.svg";

import {
  Box,
  Typography,
  Paper,
  Button,
  Container,
  Dialog,
  DialogContent,
  DialogActions,
  Link,
  Checkbox,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import LaunchIcon from "@mui/icons-material/Launch";
import CircleIcon from "@mui/icons-material/Circle";
import CompanySetupCard from "../../Components/CompanySetupCard/CompanySetupCard";

const BusinessBanking = ({ onContinue }) => {
  const [openBarclaysModel, setOpenBarclaysModel] = useState(false);
  const [barclaysConfirmationModel, setBarclaysConfirmationModel] =
    useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [showError, setShowError] = useState(false);

  const handleSubmit = () => {
    if (!isChecked) {
      setShowError(true);
      return;
    }
    setShowError(false); // Hide error if checkbox is checked
    localStorage.setItem("activeFormCompanySetup", "isBankingDetailCompleted");
    setBarclaysConfirmationModel(true);
    setOpenBarclaysModel(false);
  };

  const banks = [
    {
      id: "barclays",
      name: "Barclays Business Bank",
      logo: BarclaysLogo,
      body: (
        <>
          We've partnered with some of the UK's leading Business Banks to
          streamline the process and get you access to the best discounts
          available.
        </>
      ),
      logoBackground: "#eef5fc",
      buttonText: "OpenAccount",
      offer: "10% off",
    },
    {
      id: "monzo",
      name: "Monzo Business Bank",
      logo: MonzoLogo,
      body: (
        <>
          We've partnered with some of the UK's leading Business Banks to
          streamline the process and get you access to the best discounts
          available.
        </>
      ),
      logoBackground: "#f8f8f8",
      applicationUrl: "https://business.monzo.com/join/a/rzsj85p",
      buttonText: "OpenAccount",
    },
    {
      id: "revolut",
      name: "Revolut Business Bank",
      logo: RevolutLogo,
      body: (
        <>
          We've partnered with some of the UK's leading Business Banks to
          streamline the process and get you access to the best discounts
          available.
        </>
      ),
      logoBackground: "#f8f8f8",
      applicationUrl: "https://revolutbusiness.ngih.net/9gvG7j",
      buttonText: "OpenAccount",
    },
    {
      id: "anna",
      name: "Anna Money Business Bank",
      logo: BarclaysLogo,
      body: (
        <>
          We've partnered with some of the UK's leading Business Banks to
          streamline the process and get you access to the best discounts
          available.
        </>
      ),
      logoBackground: "#fff5f5",
      applicationUrl: "https://anna.money/",
      buttonText: "OpenAccount",
    },
  ];

  const handleOpenAccount = (bank) => {
    if (bank == "barclays") {
      setOpenBarclaysModel(true);
      return;
    }
  };

  const handleCloseBarclayModel = () => {
    setOpenBarclaysModel(false);
  };

  return (
    <Container sx={{ width: "102%" }}>
      <Paper elevation={0} sx={{ p: 0, borderRadius: 1, mt: 2 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 2,
          }}
        >
          <Typography variant="h8" fontWeight="700">
            We've partnered with the UK's leading Banks for SMES to get you the
            best offers
          </Typography>
        </Box>

        <Typography
          variant="body1"
          sx={{ mb: 3, fontWeight: "450", color: "black" }}
        >
          One of the most important aspects of running a successful business is
          staying on top of your finances set up a UK Business Bank Account in
          as little as 24-hours using the links below:
        </Typography>

        {/* Bank cards */}
        {banks.map((bank) => (
          <CompanySetupCard
            id={bank.id}
            logo={bank.logo}
            title={bank.name}
            offer={bank.offer || ""}
            body={bank.body}
            icon={LaunchIcon}
            buttonText={bank.buttonText}
            applicationUrl={bank.applicationUrl}
            handleOpenAccount={handleOpenAccount}
          />
        ))}
      </Paper>

      {/* Barclays dialog box */}
      <Dialog
        open={openBarclaysModel}
        onClose={handleCloseBarclayModel}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
            p: 4,
          },
        }}
      >
        <DialogContent sx={{ px: 4, pt: 2, textAlign: "left" }}>
          {" "}
          {/* Reduced top padding */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              mt: -5,
            }}
          >
            {" "}
            {/* Adjusted spacing */}
            <img
              src={Barclays}
              alt="Barclays Logo"
              style={{
                maxWidth: 200,
                margin: 0, // Removed bottom margin
              }}
            />
          </Box>
          <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2, mt: -3 }}>
            Set up with Barclays Business Bank 3x faster
          </Typography>
          <Typography variant="body1" sx={{ mb: 2, fontWeight: 450 }}>
            We have seamlessly integrated our platform with Barclays Business
            Bank to help speed up the process of opening up a bank account.
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, fontWeight: 450 }}>
            Tick agree if you're happy for us to pass on the necessary details
            to the Business Banking team at Barclays.
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Checkbox
              checked={isChecked}
              onChange={(e) => {
                setIsChecked(e.target.checked);
                if (e.target.checked) setShowError(false); // Hide error when checked
              }}
              sx={{
                "& .MuiSvgIcon-root": { fontSize: 22 },
                padding: 0,
                color: "#6600ff",
                alignSelf: "flex-start",
                mt: 0.3,
              }}
            />
            <Typography
              variant="body2"
              sx={{ fontSize: 14, lineHeight: 1.4, fontWeight: 440 }}
            >
              I agree that Rise Group can share my details with Barclays Bank UK
              for the creation of opening a Business Bank account. Read our{" "}
              <Link href="#" underline="always" sx={{ color: "black" }}>
                terms & conditions
              </Link>
              .
            </Typography>
          </Box>
          {showError && (
            <Typography
              variant="body2"
              sx={{ color: "red", fontSize: 12, mt: 1, ml: 4 }}
            >
              Please agree to the terms & conditions before proceeding.
            </Typography>
          )}
        </DialogContent>

        <DialogActions sx={{ px: 4, pb: 3, justifyContent: "center" }}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            sx={{
              borderRadius: 2,
              px: 6,
              height: "35px",
              py: 1,
              bgcolor: "#5000ff",
              "&:hover": {
                bgcolor: "#4400dd",
              },
            }}
          >
            Submit
          </Button>
          <Button
            variant="outlined"
            onClick={handleCloseBarclayModel}
            sx={{
              borderRadius: 2,
              px: 6,
              height: "35px",
              py: 1,
              ml: 1,
              borderColor: "#cccccc",
              color: "#333333",
            }}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      {/* Barclays confirmation dialog box */}
      <Dialog
        open={barclaysConfirmationModel}
        onClose={() => setBarclaysConfirmationModel(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
            p: 3,
          },
        }}
      >
        <DialogContent sx={{ px: 4, pt: 2, textAlign: "left" }}>
          <Box
            sx={{
              // mb: 3,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              mt: -5,
            }}
          >
            <img
              src={Barclays}
              alt="Barclays Logo"
              style={{
                maxWidth: 200,
                // marginBottom: 16,
              }}
            />
          </Box>

          <Typography
            variant="h6"
            align="center"
            sx={{
              fontWeight: "bold",
              mb: 3,
              mt: -3,
            }}
          >
            Application Submitted
          </Typography>

          <Typography variant="body1" sx={{ mb: 0, fontWeight: 450 }}>
            Your Company & Personal details have now been passed onto the
            Barclays Banking team, who will be in touch shortly either via:
          </Typography>

          <List dense sx={{ mb: 0, ml: 2 }}>
            <ListItem disableGutters>
              <ListItemIcon sx={{ minWidth: 20 }}>
                <CircleIcon sx={{ fontSize: 8, color: "black" }} />
              </ListItemIcon>
              <ListItemText
                primaryTypographyProps={{ sx: { fontWeight: "bold" } }}
                primary="Phone; or"
              />
            </ListItem>
            <ListItem disableGutters>
              <ListItemIcon sx={{ minWidth: 20 }}>
                <CircleIcon sx={{ fontSize: 8, color: "black" }} />
              </ListItemIcon>
              <ListItemText
                primaryTypographyProps={{ sx: { fontWeight: "bold" } }}
                primary="Email"
              />
            </ListItem>
          </List>

          <Typography variant="body1" sx={{ mb: 4, fontWeight: 450 }}>
            Please keep an eye out for an email or call shortly.
          </Typography>

          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <Button
              variant="contained"
              onClick={() => {
                setBarclaysConfirmationModel(false);
                // onContinue();
              }}
              sx={{
                borderRadius: 2,
                px: 6,
                height: "35px",
                py: 1,
                bgcolor: "#5000ff",
                "&:hover": {
                  bgcolor: "#4400dd",
                },
              }}
            >
              Close
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
    </Container>
  );
};
export default BusinessBanking;
